// WebAudio chime synthesizer — royalty-free.

let ctx = null;
function getCtx() {
	if (!ctx) {
		const Ctor = window.AudioContext || window.webkitAudioContext;
		if (!Ctor) return null;
		try { ctx = new Ctor(); } catch (e) { ctx = null; }
	}
	return ctx;
}

function chord(freqs, { attack = 0.008, decay = 0.25, release = 0.6, gain = 0.18, when = 0 } = {}) {
	const ac = getCtx();
	if (!ac) return;
	const now = ac.currentTime + when;
	const master = ac.createGain();
	master.gain.value = 0;

	const lp = ac.createBiquadFilter();
	lp.type = "lowpass";
	lp.frequency.value = 3200;

	master.connect(lp);
	lp.connect(ac.destination);

	freqs.forEach((f, i) => {
		const osc = ac.createOscillator();
		osc.type = i === 0 ? "sine" : "triangle";
		osc.frequency.value = f;
		const g = ac.createGain();
		g.gain.value = 0;
		osc.connect(g);
		g.connect(master);
		osc.start(now);
		g.gain.setValueAtTime(0, now);
		g.gain.linearRampToValueAtTime(gain / freqs.length, now + attack);
		g.gain.exponentialRampToValueAtTime(0.0001, now + attack + decay + release);
		osc.stop(now + attack + decay + release + 0.05);
	});

	master.gain.setValueAtTime(0, now);
	master.gain.linearRampToValueAtTime(1, now + attack);
	master.gain.exponentialRampToValueAtTime(0.0001, now + attack + decay + release);
}

export const soundEngine = {
	intro({ when = 0 } = {}) { chord([880.0, 1318.5], { when }); },
	outro({ when = 0 } = {}) { chord([440.0, 659.25], { when, gain: 0.14, decay: 0.2, release: 0.5 }); },
};
